import { ProductInstancePrice } from "./ProductInstancePrice";
export const OrderLineReferencePrice = {
    price,
};
function price(orderLineReference) {
    return ProductInstancePrice.price(ProductInstancePrice.priceSelector(orderLineReference.productInstance));
}
